import { FolkEventPropagator } from '../folk-event-propagator';
FolkEventPropagator.define();
export { FolkEventPropagator };
//# sourceMappingURL=folk-event-propagator.js.map